import { AutogenLayoutCarrierScorecardHistory } from "./autogen/AutogenLayoutCarrierScorecardHistory";
import { Panel, Table, TableRow, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { TableScorecardDetails } from "./TableScorecardDetails";
import { ModelRow, ModelSearchResult, UrlUtil } from "@mcleod/core";

export class CarrierScorecardHistory extends AutogenLayoutCarrierScorecardHistory {

    onLoad(): void | Promise<void> {
        this.addLayoutLoadListener(event => {
            const urlParams = UrlUtil.getPropsFromUrl(window.location.href);
            if (urlParams?.carrierId != null) {
                const lmData = new ModelRow("lme/powerbroker/carrier-payee", false, { id: urlParams?.carrierId });
                this.mainDataSource.searchRow.setValueAndLookupModelData("payee_id", urlParams?.carrierId, lmData);
                this.mainDataSource.displayDataInBoundSearchComponents();
                this.mainDataSource.search({ 'payee_id': urlParams.carrierId });
            }
        })
    }

     tableCarrierScorecardOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow: TableRow = event.target as TableRow;
        const expandPanel = event.expandComponentParent as Panel;
        const layoutTableScorecardDetails = expandPanel.findComponentById("layoutTableScorecardDetails") as TableScorecardDetails;
        const payee_id = tableRow.data.get("payee_id");
        const batch_number = tableRow.data.get("batch_number");
        layoutTableScorecardDetails.addLayoutLoadListener(async () => {
            layoutTableScorecardDetails.mainDataSource.search({ "batch_number": batch_number, "payee_id": payee_id });
        });
    }    
}